import {onFind} from "@elements/init-modules-in-scope";
import {findIn,findAllIn} from '@elements/dom-utils';

const selectors = {
    base: '.js-bar-charts',
    requests: '.js-bar-charts__requests',
    requestTypes: '.js-bar-charts__request-types',
};
export function init() {
    onFind(selectors.base, function (baseElement) {
        let requests = findIn(selectors.requests, baseElement);
        let requestTypes = findAllIn(selectors.requestTypes, baseElement);

        let requestAmount = requests.getAttribute('data-amount');
        let percentageRequestAmount = 100 / requestAmount;

        requestTypes.forEach(function (requestType) {
            let amount = requestType.getAttribute('data-amount');
            let percentageAmount = amount * percentageRequestAmount;

            requestType.style.width = percentageAmount + '%';
        })
    })
}